import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('Admin-Token') || '',
    name: '',
    routes: [],
    siteBranding: {
      companyName: '上海晟颢信息科技有限公司',
      companyLogo: '/logo.png',
      configLogoPath: ''
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookies.set('Admin-Token', token)
    },
    SET_NAME(state, name) {
      state.name = name
    },
    SET_ROUTES(state, routes) {
      state.routes = routes
    },
    SET_SITE_BRANDING(state, payload) {
      state.siteBranding = { ...state.siteBranding, ...payload }
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.name = ''
      state.routes = []
      Cookies.remove('Admin-Token')
    }
  }
})
